import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslocoModule} from '@jsverse/transloco';

import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';
import {MAT_DATE_LOCALE, MAT_RIPPLE_GLOBAL_OPTIONS} from '@angular/material/core';
import {MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS} from '@angular/material/slide-toggle';
import {MAT_CHECKBOX_DEFAULT_OPTIONS} from '@angular/material/checkbox';
import {MAT_FAB_DEFAULT_OPTIONS} from '@angular/material/button';

import {PageNotFoundComponent} from './components/page-not-found/page-not-found.component';
import {ToFixedStepPipe} from './pipes/to-fixed-step.pipe';
import {IconComponent} from './components/icon/icon.component';
import {SecondsToStringPipe} from './pipes/seconds-to-string.pipe';
import {MmHgToUnitPipe} from './pipes/mm-hg-to-unit.pipe';


@NgModule({
  declarations: [
    PageNotFoundComponent,
    ToFixedStepPipe,
    SecondsToStringPipe,
    MmHgToUnitPipe,
    IconComponent,
  ],
  imports: [
    CommonModule,
    TranslocoModule,
  ],
  exports: [
    ToFixedStepPipe,
    SecondsToStringPipe,
    MmHgToUnitPipe,
    IconComponent,
  ],
  providers: [
    {provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: {disabled: true}},
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        subscriptSizing: 'dynamic', // allow form field errors to be displayed on multiple lines
        appearance: 'outline',
        color: 'accent',
      },
    },
    {provide: MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS, useValue: {hideIcon: true, color: 'primary'}},
    {provide: MAT_CHECKBOX_DEFAULT_OPTIONS, useValue: {color: 'accent'}},
    {provide: MAT_FAB_DEFAULT_OPTIONS, useValue: {color: 'primary'}},
    {provide: MAT_DATE_LOCALE, useValue: 'fr-FR'},
  ]
})
export class SharedModule {
}
